var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9062 0.28125L14.7188 3.09375C15.0938 3.46875 15.0938 4.03125 14.7188 4.40625L13.0312 6.09375L8.90625 1.96875L10.5938 0.28125C10.9688 -0.09375 11.5312 -0.09375 11.9062 0.28125ZM0.28125 10.5938L7.59375 3.28125L11.7188 7.40625L4.40625 14.7188C4.21875 14.9062 4.03125 15 3.75 15H0.9375C0.375 15 0 14.625 0 14.0625V11.25C0 10.9688 0.09375 10.7812 0.28125 10.5938Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.660784e5.svg";
export { ForwardRef as ReactComponent };